var initDatePicker;
/*LGCOMMS-54 s*/
$(".support-home-type2 .service_menus .menu-item a[data-link-name='chat']").addClass("js-popup").addClass("chatbotUseEpromotor");
$(".contact-us-link-menu .menu-linkbox.chatbotUseEpromotor a").addClass("js-popup").addClass("chatbotUseEpromotor");
/*LGCOMMS-54 e*/
$(document).ready(function(){
	function callMsgCode(){
		var countrycode = document.getElementsByTagName("html")[0].getAttribute("data-countrycode");
		if(!countrycode) return false;

		var msgJson = "/" + countrycode + "/" + "js/msg.json";
		function t(t) {
			$.ajax({
				type: "get",
				url: t,
				async: false,
				dataType: "json",
				success: function(e) {
					/* jshint ignore:start */
					typeof e == "string" && (e = jQuery.parseJSON(e)),
					commonMsg = e,
					errorMsg = e.ajaxerror,
					wtbMsg = e.wheretobuy,
					alertMsg = e.alert;
					/* jshint ignore:end */
				}
			});
		}
		t(msgJson);
	}
	//callMsgCode();

	function lazyTrigger() {
		var hash = window.location.hash;
		
		if (hash) {
			$('.lazyload').each(function() {
				var $this = $(this);
				$this.attr('src', $this.data('src'));
				$this.addClass('lazyloaded')
					 .removeClass('lazyload');
			});
		}
	}

	lazyTrigger();
	/*LGEBR-321 s*/ 
	$(".modal_video").each(function(){
		$(this).click(function(e){
			e.preventDefault();
			var videoUrl=$(this).data('videoUrl');
			var videoTarget=$(this).attr('href');
			$(videoTarget).find('iframe').attr('src',videoUrl);
			$(videoTarget).click(function(){
				setTimeout(function() {
					if(!$(videoTarget).hasClass('show')){
						$(videoTarget).find('iframe').removeAttr('src');
					}
				}, 10);
			})
			$(videoTarget).find('.modal-close').click(function(){
				$(videoTarget).find('iframe').removeAttr('src');
			})
		})
	})
	/*LGEBR-321 e*/
	var smsModal = {
		el: document.getElementById("modal_sms_send"),
		form: document.getElementById("smsSendForm"),
		openBtn: document.querySelectorAll("[href='#modal_sms_send']"),
		hasCaptcha: !!$('#modal_sms_send').find('#customizedCaptcha').length,
		captchaText: $('#modal_sms_send').find('#captchaCodeTextBox'),
		content: {
			$inputCon: null,
			$completeCon: null
		},
		init: function(){
			smsModal.content.$inputCon = $(smsModal.el).find("[data-send-complete='false']");
			smsModal.content.$completeCon = $(smsModal.el).find("[data-send-complete='true']");
			smsModal.addEvent();
		},
		resetModalContent: function(){
			smsModal.content.$completeCon.hide();

			smsModal.content.$inputCon.find("input:not([type=hidden])").val("");
			smsModal.content.$inputCon.find(".field-block").removeClass("error").find(".error-msg span").hide();
			smsModal.content.$inputCon.show();
			smsModal.content.$inputCon.find(".js-scroll").mCustomScrollbar("update");
			if (!!customizedCaptcha){
				customizedCaptcha.ReloadImage();
			}
		},
		activeCompleteContent: function(result){
			var targetSelector = result ?  '.success' : '.failure';
			smsModal.content.$inputCon.hide();
			smsModal.content.$completeCon.show()
										 .find(targetSelector).show().siblings().hide();
		},
		setAjaxMsg: function(obj){
			for (var prop in obj) {
				var fieldBlock = $(smsModal.el).find("[name="+ prop +"]").closest(".field-block");
				fieldBlock.addClass("error").find(".ajax-msg").text(obj[prop]).show().siblings().hide();
			}
		},
		getSmsSendResult: function(){
			var resultUrl = $(smsModal.form).attr("data-result-url");
			if(!resultUrl) return false;

			var resultBool = false;
			var validateBool = false;
			var validateMsg;

			// get short url 
			var ajaxData = $(smsModal.form).data();
			if(ajaxData.paramName) {
				var shortUrlParam = ajaxData.paramName+"="+ajaxData.url;
				var ajaxUrl = 'https://www.lg.com/common/shorturl/getShortUrl.lgajax';

				if(ajaxData.getUrl) {
					ajaxUrl = ajaxData.getUrl;
				}
				$.ajax({
					type: "GET",
					timeout: 5e4,
					url: ajaxUrl,
					data: shortUrlParam,
					dataType: "jsonp",
					jsonp: "callback",
					success: function(data) {
						var shortUrlInput = $(smsModal.form).find('[name="shortUrl"]');
						shortUrlInput.val(data.shortUrl);
					}
				}).done(function(){
					if ( !!captcha && captcha.validation() ){
						$.ajax({
							type: "get",
							url: resultUrl,
							data: $(smsModal.form).serialize(),
							async: false,
							dataType: "json",
							success: function(data) {
								// data.result: true or false
								resultBool = data.result;
								// data.validate: true or false
								validateBool = data.validate;
								// valite error = data.error: { [inputName]: "errorMsg" }
								// result error = data.error: "ERROR errNum:015"
								validateMsg = !validateBool ? data.error : {};
							},
							error: function(request,status,error) {
								// console.log("status: "+status);
								// console.log("error: "+error);
								resultBool = false;
							}
						});

						if(validateBool){
							smsModal.activeCompleteContent(resultBool);
						}else{
							smsModal.setAjaxMsg(validateMsg);
						}

					}
				});
			}
		},
		addEvent: function(){
			$('#smsSendSubmit').on({
				click: function(e){
					e.preventDefault();
					if($(smsModal.form).checkValidation()){
						if ( smsModal.hasCaptcha ){
							if ( !!smsModal.captchaText.val() ){
								smsModal.getSmsSendResult();
							}
						} else {
							smsModal.getSmsSendResult();
						}
					}
				}
			});
			$(smsModal.openBtn).on({
				click: function(e){
					smsModal.resetModalContent();
				}
			});
		}
	};
	// add Common Support
	// ca_en postcode eventHandler
	$(document).on('input[data-postcode-type="ca_en"], input[data-postcode-type="ca_fr"]','keyup keypress paste', function( e ){
		var $this = $(this);
		//var key = e.keyCode ? e.keyCode : e.which
		var value = $this.val();
		$this.attr("maxlength", "7");
		if (value.charAt(3) != " " && value.length >= 6) {
			var s = value.substr(0, 3),
				o = value.substr(3, 3);
			$this.val(s + " " + o);
		}
		if ($this.val().length >= 7)
			return e.preventDefault(),
			!1;
		if (e.type == "paste") {
			var u = t.originalEvent.clipboardData.getData("text"),
				w = u.substr(0, 3),
				x = u.substr(3, 3);
			u.charAt(3) != " " && $this.val(w + " " + x);
		}
	});
	// masking
	$(document).on('masking', function() {
		/* LGEBR-75 20200604 modify */
		var $maskingTargets = $("[data-masked-type]");

		if ($maskingTargets.length) {
			if (!$.mask) {
				$.cachedScript( '/lg5-common-gp/library/jquery.maskedinput.min.js' ).done(function( script, textStatus ) {
					applyMaskInput($maskingTargets);
				});
			} else {
				applyMaskInput($maskingTargets);
			}
		}
		/* //LGEBR-75 20200604 modify */

		/* LGECI-217 20201015 add */
		isNumber = function(obj, strict) {
			var strict = strict === true ? true : false;
			if (strict) {
				return !isNaN(obj) && obj instanceof Number ? true : false;
			} else {
				return !isNaN(obj - parseFloat(obj));
			}
		}

		var $canadaPostal = $("[data-postcode-guest]"); // 비회원 제품등록 페이지 여부 확인

		if ($canadaPostal.length) {
			$.cachedScript( '/lg5-common-gp/library/jquery.inputmask.min.js' ).done(function( script, textStatus ) {
				$canadaPostal.inputmask("*** ***");
				$canadaPostal.on('change keyup keypress paste', function(e){
					var $this = $(this);
					var value = $this.val();
					if(isNumber(value.charAt(0)) || isNumber(value.charAt(1)) && isNumber(value.charAt(3)) && isNumber(value.charAt(4)) ){
						$(this).closest('.field-block').addClass('error');
						$(this).next('.error-msg').find('span').hide();
						$(this).next('.error-msg').find('.invalid-us').show();
					}else{
						$(this).closest('.field-block').removeClass('error');
						$(this).next('.error-msg').find('span').hide();
					}
				});
			});
		}
		/* //LGECI-217 20201015 add */

		/* LGEPL-342 20210315 add 
		** masking holder _ (언더바) string으로 인해 focus 시 커서가 맨 뒤에 위치하는 이슈 개선
		** 입력 완료했을 시엔 맨 뒤에 위치하는 게 맞음으로 last string validation 추가
		*/
		$('input[data-masked-type]').on('focus click', function(e){
			var postCodelValue = $(this).val(),
				lastIdx = parseInt(postCodelValue.length) - 1;
			if(postCodelValue.charAt(lastIdx) == '_') $(this)[0].setSelectionRange(0, 0);
		});
		/* //LGEPL-342 20210315 add */
		
		function applyMaskInput( $target ) {
			$target.each(function() {
				var type = $(this).attr("data-masked-type");
				switch (type) {
				case "BRMobile":
					// 20200406 START 구유정 || BRMobile mask 시점 click → focus 변경
					$(this).one("focus", function() {
					// 20200406 END 구유정 || BRMobile mask 시점 click → focus 변경
						$(this).mask("(99)99999-9999");
					}),
					$(this).attr("inputmode") == "numeric" && $(this).attr("type", "tel");
					break;
				case "AAA AAA":
					var postType = this.getAttribute('data-postcode-type');
					if ( postType == 'ca_en' || postType == 'ca_fr'){
						$(this).mask("AAA AAA");
					}				
					break;
				default:
					var r = $(this)[0].hasAttribute("masked-holder") ? $(this).attr("masked-holder") : type.replace(/0|9|A|\*/g, "_");
					$(this).mask(type, {
						placeholder: r
					});
				}
			});
		}
	});

	var countryCode = $('html').data('countrycode');
	// br CEP blur ajax :: get address
	if ( countryCode == 'br' ){
		$('[data-blur-action]').each(function(){
			var $this = $(this);
			var blurAction = $this.data('blurAction');


			if ( blurAction == 'cep' ){
				$this.on('blur', function(){
					var $this = $(this);
					var url = $this.data('url');
					var cep = $this.val();
					var cityTarget = $this.data('targetCity');
					var addressTarget = $this.data('targetAddress');
					var stateTarget = $this.data('targetState');
					// 20200325 START 김우람 || 3 PHASE BR nextdoor 추가 
					var nextDoorTarget = $this.data('nextdoor');
					
					if ( !url ) {
						return;
					}
					
					ajax.noCacheCall(url, {"postalCode" : cep }, 'json', function( res ){
						// 20200409 START 구유정 || CEP 관련 수정 (sign, mylg, email, request)
						/* LGEBR-535, LGEBR-779 */
						if( cityTarget ){
							if ( res.result ){
								if ($('[name='+ cityTarget +']').length){ $('[name='+ cityTarget +']').val( res.city || res.companyCity ); }
								if ($('[name='+ addressTarget +']').length){ $('[name='+ addressTarget +']').val( res.address || res.companyAddress ); }
								if ($('[name='+ stateTarget +']').length){ $('[name='+ stateTarget +']').val( res.state || res.companyState ); }
								if ($('[name='+ nextDoorTarget +']').length){ $('[name='+ nextDoorTarget +']').val( res.nextdoor || res.b2bNumComp ); }
							}else{
								if ($('[name='+ cityTarget +']').length){ $('[name='+ cityTarget +']').val(''); }
								if ($('[name='+ addressTarget +']').length){ $('[name='+ addressTarget +']').val(''); }
								if ($('[name='+ stateTarget +']').length){ $('[name='+ stateTarget +']').val(''); }
								if ($('[name='+ nextDoorTarget +']').length){ $('[name='+ nextDoorTarget +']').val(''); }
							}
						}else{
							delete res.result;
							for (var key in res) {
								$('#' + key).val(res[key]);
							}
						}
						/*// LGEBR-535, LGEBR-779 End */
						// 20200409 END 구유정 || CEP 관련 수정 (sign, mylg, email, request)
					}, 'post', 'body');
					// 20200325 END 김우람 || nextdoor 추가 
				});
				
			}
		});
	}

	// 20200402 START 김우람 || placeholder 기능 추가 
	// RU select country to set Tel Number
	if ( countryCode == 'ru' ){
		$('[data-target-post]').chosen().change(function(){			
			var select = $(this);
			var selectedOption = select.find('option:selected');
			var postCode = selectedOption.data('post');
			var placeholderMsg = selectedOption.data('placeholder-msg');

			var telLength = selectedOption.data('maxLength');

			var telInputIds = select.data('targetTel').split(',');
			var postInputIds = select.data('targetPost').split(',');
			var telInputs = [];
			var postInputs = [];
			

			$.each( telInputIds, function(){
				//telInputs.push( $('[name="'+ this +'"]') );
				telInputs.push( $(this.toString()) );
			});

			$.each( postInputIds, function(){
				//postInputs.push( $('[name="'+ this +'"]') );
				postInputs.push( $(this.toString()) );
			});

			if (!postCode){
				return;
			}

			$.each(postInputs, function(){
				this.val(postCode);
			});

			$.each(telInputs, function(){
				this.val('');
				this.attr('minlength' , telLength);
				this.attr('maxlength' , telLength);
				this.attr('placeholder', placeholderMsg);
				this.attr('disabled', false);
			});
		});
	}
	// 20200402 END 김우람 || placeholder 기능 추가 

	// 20201016 START 이하나 || [LGEEASTAF-40] eastafrica floating banner session
	if(countryCode == 'eastafrica' && !sessionStorage.getItem('inBrowser')){
		setCookie('noMoreToday',-1);
	}
	// 20201016 END 이하나 || [LGEEASTAF-40] eastafrica floating banner session

	// 210329 START 이하나 || [LGEBE-44] Postcode Validation (LGEBE-42)
	if (COUNTRY_CODE == 'be_fr'){
		var $countrySelectBox = $('.field-block select[name="countryCode"]');

		if($countrySelectBox.length){
			var postId, $postBlock,
				formTypeCheck = $countrySelectBox.attr('id');
			// select id 값으로 로드된 페이지 구분 :: sso (sign up type) - cst/acc 폼의 마크업 패턴이 다름
			// sso의 경우 old type(left-right column)으로 인해 마크업 구조로 공통 next(post box) 패턴을 찾을 수 없음 ->
			// country / post code 모두 유일한 id값으로 selector 처리
			switch(formTypeCheck){
				case 'txtBoxCountry' : // sso (sign up)
				case 'cusCountryCode' : // acc
					postId = 'txtBoxPostCode';
					break;
				case 'txtBoxCountry2' : // cst
					postId = 'contactZipCode';
					break;
			}
			$postBlock = $('input#'+postId).parent('.field-block');
			$postBlock.find('.input-info-text:not(.default)').hide();

			$countrySelectBox.chosen().change(function(){ // 다중 국가 선택 시
				var postLength,
					selectCountry = $(this).val().toLowerCase();

				switch(selectCountry){
					case 'be' : 
						postLength = 4;
						break;
					case 'lu' : 
						postLength = 6;
						break;
				}

				$('input#'+postId).val('').attr('maxlength',postLength);
				$postBlock.find('.input-info-text').hide();
				$postBlock.find('.input-info-text.'+selectCountry).show();
			});
		};
	}
	// 210329 END 이하나 || [LGEBE-44] Postcode Validation (LGEBE-42)

	// 20210621 START 이하나 || [LGEKZ-132] /kz/support/email
	var $typeOfInquiry = $('#typeOfInquiry');
	if(countryCode == 'kz' && $typeOfInquiry.length){
		var $option023 = $typeOfInquiry.find('option[value="023"]'), // OnlineShop
			$option001 = $typeOfInquiry.find('option[value="001"]'); // Installation
		$option001.after($option023);
		$typeOfInquiry.trigger("chosen:updated");
	}
	// 20210621 END 이하나 || [LGEKZ-132]

	$('[data-radiocheckbox]').each(function( idx ){
		var $container = $(this);
		var $checkboxs = $container.find('input:checkbox');

		$checkboxs.each(function(){
			var $checkbox = $(this);
			$checkbox.on('change', function(e){
				if (this.checked == true){
					$checkboxs.prop('checked', false);
					this.checked = true;
				} else {
					$checkboxs.prop('checked', false);
					this.checked = false;
				}
			});
		});
	});

	// use bootstrap Datepicker
	/* LGEBR-396 s*/
	initDatePicker = function(enabledDates) {
		var $datepicker = $('[data-provide="datepicker"]');
		$datepicker.each(function() {

			var $this = $(this),
				option = {
					orientation: 'bottom left',
					daysOfWeekHighlighted: '0',
					beforeShowDay: function (date) {
						if(enabledDates!= undefined && enabledDates.length){
							var thismonth = date.getMonth()+1;
							var thisday = date.getDate();
							if(thismonth<10){
								thismonth = "0"+thismonth;
							}
							if(thisday<10){
								thisday = "0"+thisday;
							}
							var allDates =  thisday+"/"+thismonth+"/"+date.getFullYear();
							if(enabledDates.indexOf(allDates) != -1){
								  if(date.getDay() != 0){ 
								  return true;
								  }else{
									  return false;
								  }
							  }else{
								// LGECO-310 Start : requestRepair 예약날짜 컨트롤 관련 추가
								if(enabledDates.indexOf('commonDisabledDay') != -1) { // 추가 로직
									var disableDay;
									$.each(enabledDates, function(idx, day){
										if(idx == 0) {
											return true; // continue
										} else if(idx == 1){
											disableDay = date.getDay() != Number(day)
										} else {
											disableDay = disableDay && date.getDay() != Number(day)
										}
									});
									return disableDay;
								} else {
									return false;
								}
							  }
						   }
					}
				};
			
			if ($this.data('datepicker')||$this.hasClass('hasDatePicker')) {
                //LGEMS-421 Start : 해당 클래스(date-options-control) 추가 후 옵션 설정 추가 ex) data-date-options='{"maxDate": 0}'
                if ($this.hasClass("date-options-control")) {
                    $this.datepicker('option', $this.data('dateOptions'));
                }
                //LGEMS-421 End : 옵션 설정 추가
				return;
            }
			
			// 200421 START 전호근 - format 수정
			$.extend(option, $this.data());
			($this.data('format').match(/y/g).length == 2) && (option.format = $this.data('format').replace('yy', 'yyyy'));
			//LGECL-192 , LGEPA-620
			if ($('html').data('countrycode') == 'br') {
				$.fn.datePicker.dates['en'].months = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
				$.fn.datePicker.dates['en'].monthsShort = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];
				/* LGEBR-469 */
				$.fn.datePicker.dates['en'].days = ["Domingo", "Segunda-Feira", "Terça-Feira", "Quarta-feira", "Quinta-Feira", "Sexta-Feira", "Sábado"];
				$.fn.datePicker.dates['en'].daysMin = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"];
				/*//LGEBR-469 */
				// $.fn.datePicker.dates['en'].days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
				// $.fn.datePicker.dates['en'].daysShort = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
				// $.fn.datePicker.dates['en'].daysMin = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
			}else if($('html').data('countrycode') == 'cz'){
				$.fn.datePicker.dates['en'].months = ["leden", "únor", "březen", "duben", "květen", "červen", "červenec", "srpen", "září", "říjen", "listopad", "prosinec"];
				$.fn.datePicker.dates['en'].monthsShort = ["led", "úno", "bře", "dub", "kvě", "čvn", "čvc", "srp", "zář", "říj", "lis", "pro"];
				$.fn.datePicker.dates['en'].daysMin = ["Ne", "Po", "Út", "St", "Čt", "Pá", "So"];
				$.fn.datePicker.dates['en'].dateFormat = "dd/mm/yyyy";
			}else if($('html').data('countrycode') == 'cl' || $('html').data('countrycode') == 'cac' || $('html').data('countrycode') == 'cac_en'){
				$.fn.datePicker.dates['en'].months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
				$.fn.datePicker.dates['en'].monthsShort = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];
				$.fn.datePicker.dates['en'].days = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
				$.fn.datePicker.dates['en'].daysMin = ["Dom","Lun", "Mar", "Mie", "Jue", "Vie", "Sáb"];
			}else if($('html').data('countrycode') == 'sk'){
				$.fn.datePicker.dates['en'].months = ["január", "február", "marec", "apríl", "máj", "jún", "júl", "august", "september", "october", "november", "december"];
			} // PJTGPEMP-1 add
			// 200421 END 전호근 - format 수정
			$this.datePicker(option);
			$this.addClass('hasDatePicker');
			$this.closest('.datepicker-wrap').find('.datepicker-trigger').on('click', function() {
				$this.focus();
			});
		});
	};
	/* LGEBR-396 e*/
	// default 
	if(document.getElementById('modal_sms_send')){
		smsModal.init();
	}
	$(document).trigger('masking');
	initDatePicker();

	// contact-us-link-menu show cn QR code layer
	if ( COUNTRY_CODE === 'cn') {
		$('.contact-us-link-menu .show-qrcode').attr('aria-expanded', false).on('click',function(e){
			e.preventDefault();
			var $this = $(this);
			if (!$this.is('.open')){
				$this.addClass('open');
				var $img = $this.attr('data-popoverImg');
				var qrcode = '<div class="popover-wrap below bottom center"><div class="popover-inner">';
					if ( $img.length > 0 ) {
						qrcode += '<img src="'+$img+'" alt="">';
					}
					qrcode += '<div class="btn-cover"><button type="button" role-description="layer close button"><span class="sr-only">close</span></button></div>';
					qrcode += '</div></div>';
				var linkBox = $this.parent('.menu-linkbox');
				var appendLinkBox = linkBox.css('position','relative').append(qrcode);
				$this.attr('aria-expanded', true);
				appendLinkBox.find('.btn-cover button').off('click').on('click',function(){
					$(this).parents('.popover-wrap').remove();
					linkBox.removeAttr('style');
					$this.removeClass('open');
				});
			}
			
		});
	}
	// ** contact-us-link-menu show cn QR code layer

	// 20201223 START 이하나 || [LGECI-258] [web accessibility] .inner h2.sub-title + div.XXX a.btn 존재시 - aria-describedby 연결
	$('.inner .sub-title').each(function(index){
		var hasBtn = $(this).next().find('.btn').length, // 마크업 규칙 체크
			idx = index + 1,
			labelText = 'subTitle' + idx;
		if(hasBtn){
			$(this).attr('id',labelText);
			$(this).next().find('.btn').attr('aria-describedby',labelText);
		};
	});
	// 20201223 END 이하나 || [LGECI-258]

	// 20201228 START 이하나 || [LGECI-258] [web accessibility] 
	// textarea와 연결될 .char-current 마크업이 국가별(gp all) 메시지 코드로 되어있음 
	// -> 각국 메시지 코드 수정 없이 id값 없을 경우 스크립트로 처리
	$('.question-a .char-current').each(function(){
		if(!$(this).attr('id')){
			var labelledbyText = $(this).closest('.char-count').prev().find('textarea').attr('aria-labelledby');
			$(this).attr('id',labelledbyText);
		};
	});
	// 20201228 END 이하나 || [LGECI-258]
	/*LGEMS-209 start*/
	if($("#modal_chat").length){
		$(".support-home-type2 .service_menus .menu-item a[data-link-name='chat'],.contact-us-link-menu .menu-linkbox.chat-modal a").click(function(e){
			e.preventDefault();
			$("#modal_chat").modal('show');
		})
	}
	/*LGCOMMS-54 s*/
	if($("#modal_telephone").length>0){
		$(".support-home-type2 .service_menus .menu-item a").click(function(e){
			if($(this).attr('href').indexOf('telefono')>0){
				e.preventDefault();
				$("#modal_telephone").modal('show');
			}
		})
	}
	/*LGCOMMS-54 e*/
	if($("#modal_service_whatsapp").length){
		$("#modal_service_whatsapp").modal('show');
	}
	/*LGEMS-209 end*/
	
	/* LGECO-244 Start */
	$('.floating-whatsapp .btn-whatsapp').on('click', function(e){
		var $this = $(this);
		var btnLink = $this.data('float-btn-link');
		btnLink && openWin(btnLink, '', $this.data('width') , $this.data('height'));
	})
	/* LGECO-244 End */
	

	//LGEMS-303 Start
	const targetUrl = document.location.href;
	if(targetUrl.indexOf('/mx/soporte/telefono') > -1 || targetUrl.indexOf('/mx/soporte/email') > -1
	|| targetUrl.indexOf('/in/support/telephone')> -1 || targetUrl.indexOf('/in/support/email') > -1 ){	// LGEIN-1170 add IN
		
		$('button').on('click', function(){
            const btn = $(this).attr('class');
            const target = document.querySelector('.navi-top');

            if(btn == 'modal-close'){
				target.focus();
				target.scrollIntoView();
            } else if(btn == 'btn btn-primary'){
                const btnText = $(this).text();
                if(btnText == 'Close'){
                    target.scrollIntoView();
                    target.focus();
                }
			}
		});
		
		$('#modal_service_whatsapp').on('click', function() {
			const modalClass = $(this).attr('class');
			if(modalClass.indexOf('show') <= -1){
				const target = document.querySelector('.navi-top');
				target.scrollIntoView();
				target.focus();
			}
		});
	}
	//LGEMS-303 End
	//LGEJP-643 Start
	if(targetUrl.indexOf('/jp/support/pcremote') > -1){
		let os, ua = navigator.userAgent;
		if(ua.toLowerCase().indexOf('windows') != -1) os = 'Windows';
		else os = 'etc';
		
		if(os != 'Windows'){
			$('.pc').hide();
			$('.not-pc').show();
		} else {
			$('.pc').show();
			$('.not-pc').hide();
		}

		$("#modal_modal-pcremote").off('shown.bs.modal').on('shown.bs.modal', function(){
			$(this).find('#btn-modal-close').focus();
		});
		$("#modal_modal-pcremote").off('hidden.bs.modal').on('hidden.bs.modal', function(){
			const target = document.querySelector('.btn-container');
			target.focus();
			target.scrollIntoView({block: "center"});
		});
	}
	//LGEJP-643 End
	
	// LGEITF-890 Start
	if (!!document.querySelector('.support-wrap.help-library') || !!document.querySelector('.support-wrap.video-tutorials')) {
		const gscsObj = document.querySelector('.support-wrap'),
				gscsUrl = gscsObj.dataset.url,
				gscsParam = xssfilter($('form#articleForm').serializeArray());
				
		ajax.call(gscsUrl, gscsParam, 'json');
	}
	// LGEITF-890 End
});


// 20200316 START 김우람 || newWindow 함수 추가
function newWindow(url, winW, winH, winname) {
    if (!winname || winname == "undefined") winname = "";
    var left = typeof window.screenLeft != "undefined" ? window.screenLeft : screen.left;
    var top = typeof window.screenTop != "undefined" ? window.screenTop : screen.top;
    var x = screen.width / 2 - winW / 2 + screenX;
    var y = screen.height / 2 - winH / 2 + screenY;

    if (url == "about:blank") linkurl = url;
    else linkurl = url.href;

    window.name = 'openerWindow';
    window.open(linkurl, winname, 'resizable=yes,scrollbars=yes,height=' + winH + ',width=' + winW + ',left=' + x + ',top=' + y);
}
// 20200316 END 김우람 || newWindow 함수 추가

/* LGCOMSPEED-6 Start : common.js에서 옮김 */
//adobe (cs > psp page > download)
(function ($) {
	if($('.support-downloads').length>0) {
		$obj=$('.support-downloads .list>li .name a.link-text');
		$obj.on('click', function() {
			var fileName = "";
			if($(this).closest('li').hasClass('manuals')) {
				// cs > psp page > Manuals & Documents
				var $pobj = $('.support-product-area .text-block .model');
				var tempname = $pobj.text();
				if($pobj.find('.name').length>0) tempname = tempname.replace($pobj.find('.name').text(), '');
				fileName = changeTitleFormat($(this).closest('li').find('.type').text()) + ':' + changeTitleFormat(tempname) + ':' + changeTitleFormat($(this).text());
				adobeTrackEvent('cs-psp-download', {download_file_type : "manuals_documents", download_file_name: fileName, page_event : {cs_file_download : true}});
			} else if($(this).closest('li').hasClass('software')) {
				// cs > psp page >Software & Drivers
				var $pobj2 = $('.support-product-area .text-block .model');
				var tempname2 = $pobj2.text();
				if($pobj2.find('.name').length>0) tempname2 = tempname2.replace($pobj2.find('.name').text(), '');
				fileName = changeTitleFormat($(this).closest('li').find('.type').text()) + ':' + changeTitleFormat(tempname2) + ':' + changeTitleFormat($(this).text());
				adobeTrackEvent('cs-psp-download', {download_file_type : "software_drivers", download_file_name: fileName, page_event : {cs_file_download : true}});
			}
		});
	}
})(jQuery);
/*// LGCOMSPEED-6 End : common.js에서 옮김 */